import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/esnext.string.match-all.js";
var e = /\n/g;
function n(n) {
  var o = _toConsumableArray(n.matchAll(e)).map(function (e) {
    return e.index || 0;
  });
  o.unshift(-1);
  var s = t(o, 0, o.length);
  return function (e) {
    return r(s, e);
  };
}
function t(e, n, r) {
  if (r - n == 1) return {
    offset: e[n],
    index: n + 1
  };
  var o = Math.ceil((n + r) / 2),
    s = t(e, n, o),
    l = t(e, o, r);
  return {
    offset: s.offset,
    low: s,
    high: l
  };
}
function r(e, n) {
  return function (e) {
    return Object.prototype.hasOwnProperty.call(e, "index");
  }(e) ? {
    line: e.index,
    column: n - e.offset
  } : r(e.high.offset < n ? e.high : e.low, n);
}
function o(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var o = "string" != typeof t ? t : r,
    l = "string" == typeof t ? t : "",
    c = e.map(s),
    f = !!o.lineNumbers;
  return function (e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var r = f ? n(e) : function () {
      return {
        line: 0,
        column: 0
      };
    };
    var o = t;
    var s = [];
    e: for (; o < e.length;) {
      var _n = !1;
      var _iterator = _createForOfIteratorHelper(c),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t = _step.value;
          _t.regex.lastIndex = o;
          var _c = _t.regex.exec(e);
          if (_c && _c[0].length > 0) {
            if (!_t.discard) {
              var _e = r(o),
                _n2 = "string" == typeof _t.replace ? _c[0].replace(new RegExp(_t.regex.source, _t.regex.flags), _t.replace) : _c[0];
              s.push({
                state: l,
                name: _t.name,
                text: _n2,
                offset: o,
                len: _c[0].length,
                line: _e.line,
                column: _e.column
              });
            }
            if (o = _t.regex.lastIndex, _n = !0, _t.push) {
              var _n3 = _t.push(e, o);
              s.push.apply(s, _toConsumableArray(_n3.tokens)), o = _n3.offset;
            }
            if (_t.pop) break e;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (!_n) break;
    }
    return {
      tokens: s,
      offset: o,
      complete: e.length <= o
    };
  };
}
function s(e, n) {
  return _objectSpread(_objectSpread({}, e), {}, {
    regex: l(e, n)
  });
}
function l(e, n) {
  if (0 === e.name.length) throw new Error("Rule #".concat(n, " has empty name, which is not allowed."));
  if (function (e) {
    return Object.prototype.hasOwnProperty.call(e, "regex");
  }(e)) return function (e) {
    if (e.global) throw new Error("Regular expression /".concat(e.source, "/").concat(e.flags, " contains the global flag, which is not allowed."));
    return e.sticky ? e : new RegExp(e.source, e.flags + "y");
  }(e.regex);
  if (function (e) {
    return Object.prototype.hasOwnProperty.call(e, "str");
  }(e)) {
    if (0 === e.str.length) throw new Error("Rule #".concat(n, " (\"").concat(e.name, "\") has empty \"str\" property, which is not allowed."));
    return new RegExp(c(e.str), "y");
  }
  return new RegExp(c(e.name), "y");
}
function c(e) {
  return e.replace(/[-[\]{}()*+!<=:?./\\^$|#\s,]/g, "\\$&");
}
export { o as createLexer };